const styles = (theme) => ({
  container: {
    position: "absolute",
    top: 30,
    width: 364,
    minHeight: 100,
    maxHeight: 200,
    overflowY: "auto",
    right: 8,
    boxShadow: `0px 4px 4px ${theme.shadowColor}`,
    backgroundColor: theme.ModalBGColor,
    color: theme.notificationColor,
  },
  notificationWrapper: {
    position: "relative",
  },
  emptyMsgContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
  emptyMsgIcon: { fontSize: "45px", marginBottom: "10px" },
  alertNotification: {
    height: "auto",
  },
});

export default styles;
